export class Project {
    name: string;
    email: string;
    project_and_period_start: string;
    work_place: string;
    qualifications_and_supplies: string;
}